import { useEffect } from 'react'
import { getAuth } from 'firebase/auth'
import { useDispatch } from '../../redux/hooks'
import authActions from '../../redux/modules/auth/actions'
import { routes, publicRoutes } from '../../routes'
import config from '../../config'

export const useSubscribeToAuthState = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    return getAuth().onAuthStateChanged(currentUser => {
      if (!currentUser) {
        if (!publicRoutes.includes(window.location.pathname as (typeof publicRoutes)[0])) {
          window.location.pathname = routes.login
        }
        dispatch(authActions.loggedOut())
        if (config.prod) {
          document.cookie = `tm_li=0; Domain=.trademailer.co.uk; Path=/; Max-Age=2592000; Secure; SameSite=Lax`
        }
      } else {
        if (config.prod) {
          document.cookie = `tm_li=1; Domain=.trademailer.co.uk; Path=/; Max-Age=2592000; Secure; SameSite=Lax`
        }
      }
    })
  }, [dispatch])
}
